import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import DateInput from "Components/molecule/inputs/date-input"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import MultiSelect from "Components/molecule/inputs/multi-select"
import TextInput from "Components/molecule/inputs/text-input"
import { IIndustryEngagementQueryParams } from "models/industry-engagement"
import { SelectOption } from "Components/molecule/inputs/select-input"
import { useMemo } from "react"
import useEnterSearch from "hooks/useEnterSearch"

interface SearchIndustryEngagementFormProps {
    handleChangeQuery: (key: keyof IIndustryEngagementQueryParams, value: any) => any
    handleClearSearch: () => any
    handleSearch: () => any
    statuses: SelectOption[]
    attendees: SelectOption[]
    opportunities: SelectOption[]
    query: IIndustryEngagementQueryParams
    isSearching: boolean
}

const SearchIndustryEngagementForm = ({
    handleChangeQuery,
    handleClearSearch,
    handleSearch,
    statuses,
    attendees,
    opportunities,
    query,
    isSearching
}: SearchIndustryEngagementFormProps) => {

    const { inputProps } = useEnterSearch(handleSearch)

    const selectedStatuses = useMemo(() => {
        return statuses.filter(s => query.statusIds?.includes(s.value))
    }, [query, statuses])

    const selectedAttendees = useMemo(() => {
        return attendees.filter(a => query.attendeeIds?.includes(a.value))
    }, [query, attendees])

    const selectedOpportunities = useMemo(() => {
        return opportunities.filter(o => query.opportunityIds?.includes(o.value))
    }, [query, opportunities])

    return (
        <SearchFormContainer
            inputs={
                <>
                    <TextInput
                        label="Event"
                        placeholder="Event name"
                        value={query.name ?? ''}
                        onChange={(e) => handleChangeQuery('name', e.target.value)}
                        {...inputProps}
                    />

                    <MultiSelect
                        label="Status"
                        options={statuses}
                        value={selectedStatuses}
                        onChange={(vals: SelectOption[]) =>
                            handleChangeQuery('statusIds', vals.length ? vals.map(v => v.value) : undefined)
                        }
                        placeholder="Select statuses"
                    />

                    <MultiSelect
                        label="Attendees"
                        options={attendees}
                        value={selectedAttendees}
                        onChange={(vals: SelectOption[]) =>
                            handleChangeQuery('attendeeIds', vals.length ? vals.map(v => v.value) : undefined)
                        }
                        placeholder="Select attendees"
                    />

                    <MultiSelect
                        label="Opportunities"
                        options={opportunities}
                        value={selectedOpportunities}
                        onChange={(vals: SelectOption[]) =>
                            handleChangeQuery('opportunityIds', vals.length ? vals.map(v => v.value) : undefined)
                        }
                        placeholder="Select opportunities"
                    />

                    <DateInput
                        label="Date From"
                        placeholder="From"
                        value={query.dateFrom ?? ''}
                        onChange={(e) => handleChangeQuery('dateFrom', e.target.value || undefined)}
                    />

                    <DateInput
                        label="Date To"
                        placeholder="To"
                        value={query.dateTo ?? ''}
                        onChange={(e) => handleChangeQuery('dateTo', e.target.value || undefined)}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton
                        style={{ minWidth: '150px' }}
                        disabled={isSearching}
                        onClick={handleSearch}
                    >
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{ minWidth: '100px' }}
                        disabled={isSearching}
                        onClick={handleClearSearch}
                    >
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )
}

export default SearchIndustryEngagementForm